import { useUserContext } from "@context/UserContext";
import { AnalyticsEvent, AnalyticsLocation } from "@appTypes/analytics";

const useSegment = () => {
  const { user } = useUserContext();

  const trackEvent = (event: AnalyticsEvent, feature: string, location: AnalyticsLocation, details?: string): void => {
    if (!window.analytics) {
      return;
    }

    if (!user) {
      return;
    }

    window.analytics.track(event, {
      feature,
      location,
      details,
      user_type: user.userType,
    });
  };

  return { trackEvent };
};

export default useSegment;
